import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-dropdown';
import { translate } from 'react-i18next';

// Import components
import FlyoutTile from './FlyoutTile';
import Slider from '../../../Util/Slider/SliderView';

// Import assets
import './flyout.scss';
import '../../../../../assets/icons/Lenspire_Icon_Check.svg';
import '../../../../../assets/icons/Lenspire_Icon_CloseButton.svg';

const FlyoutView = (props) => {
  let className = 'm-flyout';
  if (props.visible) {
    className += ' m-flyout--visible';
  }
  if (props.mobile) {
    className += ' m-flyout--mobile';
  }

  if (props.visible) {
    return (
      <div className={className}>
        <div className="m-flyout__upper">
          <button className="a-button a-button--small a-button--black" onClick={props.unsetAllSubCategories}>{props.t('translations.Clear all filters')}
            <span>
              <svg>
                <use xlinkHref="#Lenspire_Icon_CloseButton" />
              </svg>
            </span>
          </button>
        </div>
        <Slider className="m-flyout__slider" forceRerender={props.visible}>
          {props.subcategories.map(subcategory => (
            <FlyoutTile
              subcategory={subcategory}
              key={subcategory.id}
              addActiveSubCategory={props.addActiveSubCategory}
              removeActiveSubCategory={props.removeActiveSubCategory}
              toggleActiveSubCategory={props.toggleActiveSubCategory}
              isActiveSubCategory={props.isActiveSubCategory}
            />
          ))}
        </Slider>
        <div className="m-flyout__lower">
          <span className="m-flyout__label">{props.t('translations.Sort Photos by')}</span>
          <Dropdown
            className="m-flyout__dropdown m-dropdown"
            value={{ value: 'recent', label: props.t('translations.Most recent') }}
            options={[
              { value: 'recent', label: props.t('translations.Most recent') },
              { value: 'popular', label: props.t('translations.Most popular') },
            ]}
          />
          <button className="a-button a-button--large a-button--blue" onClick={props.filterTiles}>{props.t('translations.Filter now')}</button>
        </div>
      </div>
    );
  }

  return null;
};

FlyoutView.propTypes = {
  visible: PropTypes.bool,
  mobile: PropTypes.bool,
  subcategories: PropTypes.arrayOf(PropTypes.shape()),
  addActiveSubCategory: PropTypes.func,
  removeActiveSubCategory: PropTypes.func,
  toggleActiveSubCategory: PropTypes.func,
  isActiveSubCategory: PropTypes.func,
  t: PropTypes.func.isRequired,
  filterTiles: PropTypes.func,
  unsetAllSubCategories: PropTypes.func,
};

FlyoutView.defaultProps = {
  visible: false,
  mobile: false,
  subcategories: [],
  unsetAllSubCategories: () => {
  },
  addActiveSubCategory: () => {
  },
  removeActiveSubCategory: () => {
  },
  toggleActiveSubCategory: () => {
  },
  filterTiles: () => {
  },
  isActiveSubCategory: () => {
  },
};

export default translate()(FlyoutView);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/Flyout/FlyoutView.jsx